export const nomesEmpresas : any[] =[{cnpj: '07121081000127', descricao: 'Venda Mais'},
                                     {cnpj: '07121081000133', descricao: 'IntegraWeb'}];


// WEBPACK FOOTER //
// ./src/app/login/nomes_empresas.ts